import React from "react";
import { useTranslation } from "react-i18next";

const AboutOffer = () => {
  const { t } = useTranslation();
  return (
    <div className="container mx-auto  px-2 relative mt-11 xl:max-w-[1200px]  3xl:max-w-[1400px] lg:mt-[280px] xl:mt-[230px] 3xl:mt-[300px] mb-[30px] sm:mb-[50px] lg:mb-[100px]  3xl:mb-[200px]">
      <div
        className="flex flex-col h-[auto] lg:h-[400px] unset lg:relative lg:flex-row  justify-around py-[20px] px-[10px] sm:py-[28px] sm:px-[40px]
   md:px-[40px] md:py-[36px] lg:px-[53px] bg-[#F3F6FF] rounded-[16px] sm:rounded-[50px]"
      >
        <div
          className="rounded-[10px]  sm:rounded-[30px] border border-[##E4EBFF]  bg-white w-[100%] lg:w-[43%]   p-[40px] sm:p-[30px]  md:p-[50px] unset lg:absolute bottom-[30%] left-[5%]"
          style={{
            boxShadow:
              " 0px 4px 9px 0px rgba(191, 169, 199, 0.2), 0px 16px 16px 0px rgba(191, 169, 199, 0.17), 0px 36px 22px 0px rgba(191, 169, 199, 0.1), 0px 64px 26px 0px rgba(191, 169, 199, 0.03), 0px 100px 28px 0px rgba(191, 169, 199, 0)",
          }}
        >
          <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
            {t("what")}
          </h1>
          <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000] mb-5">
            {t("we_offer")}
          </h1>
          <span className="sora text-[14px] 3xl:text-[18px] font-[400] leading-[30px] text-[#444]">
            {t("we_offer_desc")}
          </span>
        </div>
        <div
          className="rounded-[10px]  sm:rounded-[30px] mt-[20px] lg:mt-0 border border-[##E4EBFF]  bg-white w-[100%] lg:w-[43%] p-[40px] sm:p-[30px] md:p-[50px] unset lg:absolute  bottom-[-10%] right-[5%]"
          style={{
            boxShadow:
              "0px 4px 9px 0px rgba(191, 169, 199, 0.20), 0px 16px 16px 0px rgba(191, 169, 199, 0.17), 0px 36px 22px 0px rgba(191, 169, 199, 0.10), 0px 64px 26px 0px rgba(191, 169, 199, 0.03), 0px 100px 28px 0px rgba(191, 169, 199, 0.00)",
          }}
        >
          <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000]">
            {t("why")}
          </h1>
          <h1 className="sora text-[22px] sm:text-[32px] 3xl:text-[54px] font-[700]  leading-[30px] sm:leading-[40px] 3xl:leading-[60px] text-[#000] mb-5">
            {t("choose_us")}
          </h1>
          <span className="text-[14px] 3xl:text-[18px] font-[400] leading-[26px] text-[#444]">
            <ul className="list-square">
              <li className="sora mb-3"><b className="sora">{t("reduced_costs")}:</b> {t("reduced_costs_desc")}</li>
              <li className="sora mb-3"><b className="sora">{t("future_proof_technology")}:</b> {t("future_proof_technology_desc")}</li>
              <li className="sora mb-3"><b className="sora">{t("enhanced_security")}:</b> {t("enhanced_security_desc")}</li>
              <li className="sora mb-3"><b className="sora">{t("effortless_integration")}:</b> {t("effortless_integration_desc")}</li>
            </ul>
          </span>
        </div>
      </div>
    </div>
  );
};

export default AboutOffer;
